export enum EnvironmentEnum {
    DEV = 'dev',
    PROD = 'prod',
    STAGING = 'staging'
}